import { useTranslation } from "react-i18next";
import { styled } from "./RolesOverviewTemplate.styles";
import { useGetRoles } from "@/src/lib/useGetRoles/useGetRoles";
import { useState } from "react";
import RolesTable from "../../organisms/RolesTable/RolesTable";
import { useNavigate } from "@tanstack/react-router";
import { usePermissions } from "@/src/lib/usePermissions/usePermissions";

const RolesOverviewTemplate = () => {
    const { t } = useTranslation("common", {
        keyPrefix: "roles-overview",
    });

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(15);

    const { roles, loading, count } = useGetRoles(page, pageSize);

    const navigate = useNavigate();
    const handleItemClick = (id: string) => {
        navigate({ to: `/admin/roles/${id}` });
    };

    const { hasPermission } = usePermissions();

    const onItemClick = hasPermission("ROLES_UPDATE")
        ? handleItemClick
        : undefined;

    return (
        <>
            <styled.Container>
                <styled.Header
                    title={t("title")}
                    {...(hasPermission("ROLES_CREATE") && {
                        button: {
                            to: "new",
                            label: t("new-role"),
                        },
                    })}
                />
                <styled.Main>
                    <RolesTable
                        roles={roles}
                        loading={loading}
                        onItemClick={onItemClick}
                        page={page}
                        rowsPerPage={pageSize}
                        totalCount={count}
                        onPageChange={(event, newPage) => setPage(newPage)}
                        onRowsPerPageChange={(event) =>
                            setPageSize(parseInt(event.target.value, 10))
                        }
                    />
                </styled.Main>
            </styled.Container>
        </>
    );
};

export default RolesOverviewTemplate;
